/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// A Dialog with static content. Available in a link for every one of My Products.
@Component({
  selector: 'wsn-sys-net-requirements',
  templateUrl: './sys-net-requirements.component.html',
  styleUrls: ['./sys-net-requirements.component.scss']
})
export class SysNetRequirementsComponent {
  constructor(public dialogRef: MatDialogRef<SysNetRequirementsComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  close() {
    this.dialogRef.close();
  }
}
